import { Menu, Transition } from '@headlessui/react';
import { Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Icon, { IconSize } from '~/components/common/icon.component';
import classNames from 'classnames';
import OptionsMenuItem from './options-menu-item.component';

interface OptionsMenuProps {
  menuButton?: ReactNode;
  buttonClassName?: string;
  options?: { label: string; onClick?: () => void; icon?: string }[];
  srLabel?: string;
  children?: ReactNode;
}

const OptionsMenu = ({
  options,
  srLabel,
  menuButton,
  buttonClassName,
  children,
}: OptionsMenuProps) => {
  const { t } = useTranslation();
  return (
    <Menu
      as="div"
      className="ml-3 relative z-50"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {({ open }) => (
        <>
          <div>
            <Menu.Button
              className={classNames(
                'p-2 max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary',
                buttonClassName,
              )}
              onClick={(e) => e.stopPropagation()}
            >
              <span className="sr-only">
                {srLabel || t('open options menu')}
              </span>
              {menuButton || (
                <Icon name="DotsVerticalIcon" size={IconSize.Large} />
              )}
            </Menu.Button>
          </div>
          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
            >
              {options?.map((option) => (
                <OptionsMenuItem
                  key={option.label}
                  onClick={option.onClick}
                  icon={option.icon}
                >
                  {option.label}
                </OptionsMenuItem>
              ))}
              {children}
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};

OptionsMenu.Item = OptionsMenuItem;

export default OptionsMenu;
